<template>
  <div>
    <span>
      <button
        v-on:click="alimSec()"
        style="border: none; background: none; margin-right: 5px"
      >
        <box-icon
          style="float: right"
          name="list-check"
          animation="tada-hover"
          color="#28c76f"
          class="text-body align-middle mr-25"
        ></box-icon>
      </button>
      <button
        v-on:click="stokSil()"
        style="border: none; background: none; margin-right: 5px"
      >
        <box-icon
          style="float: left"
          name="trash"
          animation="tada-hover"
          color="#ea5455"
          class="text-body align-middle mr-25"
        ></box-icon>
      </button>
      <button
        v-on:click="stokEkstre()"
        style="border: none; background: none; margin-right: 5px"
      >
        <box-icon
          style="float: right"
          name="search-alt-2"
          animation="tada-hover"
          color="#7367F0"
          class="text-body align-middle mr-25"
        ></box-icon>
      </button>
    </span>

    <SepetGuncelle ref="sepet" :gelenDurum="gelenDurum" />
    <StokEkstre ref="ekstre" />
  </div>
</template>
<script>
import moment from "moment";
import "boxicons";
import SepetGuncelle from "../stok-components/SepetGuncelle.vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import StokEkstre from "../stok-components/StokEkstre.vue";
export default {
  data() {
    return { gelenDurum: "true" };
  },
  components: { SepetGuncelle, StokEkstre },
  methods: {
    stokEkstre() {
      console.log(this.params.data);
      this.$store.commit(
        "account/STOKSTOCKNAME_TUT",
        this.params.data.STOCKNAME
      );
      this.$store.commit("account/STOKID_TUT", this.params.data.STOCKID);
      this.$store.commit("account/STOKSTOCKNO_TUT", this.params.data.STOCKNO);
      this.$refs.ekstre.stokEkstreDetay();
    },
    stokSil() {
      var vs = this.$vs;
      //  this.$emit("talepHavuzuList");
      console.log(this.params.data);
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var stokid = this.params.data.STOCKID;
      var itemno = this.params.data.ITEMNO;
      var receipt = this.params.data.RECEIPTID;

      var args = {
        ISLEM: "DELETE",
        RECEIPTID: receipt,
        STOCKID: stokid,
        ITEMNO: itemno,
        token: Store.state.tokenId,
        QUANTITY: "",
        PRICE: "",
        DESCRIPTION: "",
        ACTID: "",
        REQUIREDDATE: "",
        TOTAL: "",
        STATUS: "",
      };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_Sal_SatinalmaTalepIslem(args, function (err, result) {
          if (result.INT_Sal_SatinalmaTalepIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Sal_SatinalmaTalepIslemResult);
            console.log(vm.veriler);
            vs.notify({
              title: "Silindi",
              text: "İşlem Başarıyla Gerçekleşti",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            console.log(result);
          }
        });
      });
      this.$root.$emit("talepHavuzuList");
    },
    alimSec() {
      console.log(this.params.data);
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (this.params.data.IND1 == "" || typeof this.params.data.IND1 == "undefined")
        this.params.data.IND1 = 0;
      if (this.params.data.IND2 == "" || typeof this.params.data.IND2 == "undefined")
        this.params.data.IND2 = 0;
      if (this.params.data.IND3 == "" || typeof this.params.data.IND3 == "undefined")
        this.params.data.IND3 = 0;
      var args = {
        ISLEM: "UPDATE",
        STOCKID: this.params.data.STOCKID,
        RECEIPTID: "606", //this.params.data.RECEIPTID,
        ITEMNO: "7", //this.params.data.ITEMNO,
        QUANTITY: this.params.data.QUANTITY,
        PRICE: this.params.data.PRICE,
        TOTAL: this.params.data.PRICE * this.params.data.QUANTITY,
        DESCRIPTION: "",
        REQUIREDDATE: "2023-01-01", //moment(String(this.params.data.REQUIREDDATE)).format("YYYY-DD-MM"),
        ACTID: Store.state.account.planlamaCariId, //Store.state.account.satinalmaPlanlamaACTID, //ACTID 0 ise
        token: Store.state.tokenId,
        STATUS: "2",
        IND1: this.params.data.IND1,
        IND2: this.params.data.IND2,
        IND3: this.params.data.IND3,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_Sal_SatinalmaTalepIslem(args, function (err, result) {
          if (result.INT_Sal_SatinalmaTalepIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          console.log(result);
          try {
            vm.veriler = JSON.parse(result.INT_Sal_SatinalmaTalepIslemResult);
            vs.notify({
              title: "Sepet",
              text: "Güncellendi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            vs.notify({
              title: "Güncelleme",
              text: "Güncellenirken Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    talepHavuzuListesi() {
      console.log("geldii");
      this.$emit("denemecagir");
    },
  },
};
</script>